/**
 * Skip-link target id and click handler (2.4.1).
 *
 * Target is a zero-size `tabIndex={-1}` sentinel inside `<main>`, not `<main>` itself — a
 * focusable `<main>` steals focus from clicks on page text, so Tab restarts at the first control.
 * `preventDefault` keeps the hash out of the URL; `focus()` still scrolls the sentinel into view.
 */
export const SKIP_LINK_TARGET_ID = 'appLayoutMainSkipTarget'

/**
 * `decodeURIComponent` throws a `URIError` on malformed percent-encoding (`#%E0%A4%A`). A click
 * handler must never throw, so fall back to the raw fragment and let the browser's own fragment
 * navigation handle anything we cannot resolve.
 */
const fragmentToId = (hash: string): string => {
  const raw = hash.slice(1)
  try {
    return decodeURIComponent(raw)
  } catch {
    return raw
  }
}

export function focusSkipLinkTarget(event: { currentTarget: HTMLAnchorElement; preventDefault: () => void }): void {
  const { hash } = event.currentTarget
  const target = hash ? document.getElementById(fragmentToId(hash)) : null
  if (!target) return
  event.preventDefault()
  target.focus()
}
